// extracted by mini-css-extract-plugin
export default {"customerChatRoomSendDiv":"CustomerChatRoomSend_customerChatRoomSendDiv__iOymM","customerChatRoomSendBtn":"CustomerChatRoomSend_customerChatRoomSendBtn__16FZ2"};